module.exports = __webpack_public_path__ + "static/img/Hussar_theme_face.ab214aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/Hussar_theme_face.png
// module id = dDhq
// module chunks = 0